import { TODAY_DATE } from '@barbershop/shared/model'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { AppointmentsPage } from '@/pages/appointments-page'

const AppointmentsSearchSchema = z.object({
    date: z.iso.date().default(TODAY_DATE),
})

export const Route = createFileRoute('/_dashboard-layout/appointments')({
    component: AppointmentsPage,
    validateSearch: AppointmentsSearchSchema,
})
